import React, { useEffect, useRef, useState } from "react";

/**
 * CustomCursor - a minimal cyan dot + soft ring that follows the mouse.
 * Expands over interactive elements. Hidden on touch devices via CSS.
 */
const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) { setEnabled(false); return; }

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    let rx = mx;
    let ry = my;
    let raf = 0;

    const onMove = (e) => {
      mx = e.clientX; my = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mx}px, ${my}px) translate(-50%, -50%)`;
      }
    };
    const tick = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(tick);
    };
    const onOver = (e) => {
      const interactive = e.target.closest("a, button, input, textarea, [data-cursor='hover']");
      if (!ringRef.current || !dotRef.current) return;
      if (interactive) {
        ringRef.current.style.width = "52px";
        ringRef.current.style.height = "52px";
        ringRef.current.style.borderColor = "rgba(0,240,255,0.9)";
        dotRef.current.style.opacity = "0.4";
      } else {
        ringRef.current.style.width = "38px";
        ringRef.current.style.height = "38px";
        ringRef.current.style.borderColor = "rgba(0, 240, 255, 0.5)";
        dotRef.current.style.opacity = "1";
      }
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });
    raf = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div ref={ringRef} className="cursor-ring" data-testid="cursor-ring" />
      <div ref={dotRef} className="cursor-dot" data-testid="cursor-dot" />
    </>
  );
};

export default CustomCursor;
